<template>
  <div class="theme-content">
    <div class="form-box">
      <form
        id="cgForm"
        action="https://sfx-86fdu.hosted.exlibrisgroup.com.cn/cgi-bin/86fdu/ej.cgi"
        method="get"
        target="_blank"
      >
        <!-- <input name="func" value="find-db-1-lcl" type="hidden" />
        <input name="func" value="quick-1-check1-lcl" type="hidden" />
        <input name="mode" value="simple" type="hidden" /> -->
        <input id="select3" name="typ" v-model="curSearchWay" />
        <input name="s" v-model="searchValue" />
      </form>
    </div>

    <div class="block-search">
      <div class="image-text_2">
        <div class="section_8 flex-row">
          <span class="search-condtion">{{ getNameById(curSearchWay) }}</span>
          <img
            class="search-way-icon"
            referrerpolicy="no-referrer"
            src="../../../assets/search-way.png"
          />
          <div class="show-select-condtion">
            <div
              v-for="item in searchWay"
              :class="curSearchWay == item.value ? 'selected-item' : ''"
              :key="item.value"
              @click="selectWayItem(item.value)"
            >
              <div class="show-select-item">{{ item.name }}</div>
            </div>
          </div>
        </div>
        <div class="search-input-box">
          <input
            type="input"
            @keyup.enter="searchSubmit"
            v-model="searchValue"
            placeholder="根据选择条件输入相应的搜索值"
            class="search-input"
          />
        </div>
        <div class="search-bnt search-bnt1 flex-col" @click="searchSubmit()">
          <span>搜索</span>
        </div>
      </div>
    </div>
    <img
      class="image_4"
      referrerpolicy="no-referrer"
      src="../../../assets/search-input-bg.png"
    />
    <div class="theme-info">{{ info }}</div>
    <div class="link_wrap">
      <a
        href="https://sfx-86fdu.hosted.exlibrisgroup.com.cn/ej/86fdu/ej.htm"
        target="_blank"
      >
        电子期刊导航
      </a>

      <a
        href="http://sfx-86ali.hosted.exlibrisgroup.com.cn/index.html"
        target="_blank"
      >
        核心期刊查询系统
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {
      showForm: false,
      drawer: false,
      themeId: 1,
      searchValue: "",
      id: 4,
      name: "电子期刊",
      curSearchWay: "0",
      searchWay: [
        { value: "0", name: "刊名" },
        { value: "3", name: "ISSN" },
      ],
      info: "说明：查找本校读者可利用的电子期刊，包括本馆订购期刊和免费期刊。",
    };
  },
  watch: {
    $route: {
      handler(to) {
        this.isPosition = to.path === "/home";
      },
      immediate: true,
    },
  },
  computed: {
    currentPath() {
      return this.$route.path;
    },
  },
  methods: {
    selectWayItem(value) {
      this.curSearchWay = value;
    },
    getNameById(value) {
      const record = this.searchWay;
      const data = record.find((item) => item.value === value);
      return data.name;
    },
    searchSubmit() {
      if (this.searchValue) {
        let form = document.getElementById("cgForm");
        form.submit();
      }
    },
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.form-box {
  display: none;
}
.block-search {
  // width: 1228px;
  // margin: 19px 0 0 133px;
  margin-top: 20px;
  height: 58px;
  background: #fff;

  .section_8 {
    background-color: rgba(0, 72, 150, 1);
    width: 157px;
    height: 57px;
    position: relative;
    cursor: pointer;
  }

  .section_8:hover .show-select-condtion {
    display: block;
  }

  .search-way-icon {
    width: 15px;
    height: 6px;
    margin: 28px 13px 0 30px;
  }

  .search-condtion {
    width: 100px;
    height: 22px;
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    text-align: right;
    white-space: nowrap;
    line-height: 33px;
    margin: 14px 0 0 0;
    padding: 0px 6px;
    font-size: 18px;
    font-weight: 700;
  }

  .show-select-condtion {
    width: 157px;
    position: absolute;
    top: 58px;
    display: none;
    max-height: 260px;
    overflow-y: auto;
    background-color: rgba(0, 72, 150, 1);
    color: #fff;
    .show-select-item {
      padding: 10px 6px;
      border-bottom: 1px solid #fff;
    }
    .selected-item {
      background: rgba(255, 255, 255, 0.2);
    }
  }

  .search-input-box {
    flex: 1;
    .search-input {
      // width: 800px;
      width: 100%;
      height: 58px;
      line-height: 58px;
      background: 0 0;
      font-size: 16px;
      letter-spacing: 0;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      padding: 0;
      border: 0;
      outline: 0;
      margin-left: 20px;
    }
  }
}

.image-text_2 {
  display: flex;
  align-items: center;
  padding-right: 20px;
}

.search-bnt {
  height: 48px;
  line-height: 48px;
  text-align: center;
  color: rgba(255, 255, 255, 1);
  font-size: 18px;
  font-weight: 900;
  border-radius: 5px;
  cursor: pointer;
}

.search-bnt1 {
  background-color: rgba(236, 108, 0, 1);
  width: 106px;
  // margin: 5px 0 0 790px;
  margin-left: auto;
}

.image_4 {
  position: relative;
  width: 100%;
  height: 2px;
  top: -10px;
  // margin: -10px 0 0 303px;
}

.theme-info {
  width: 612px;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  text-align: left;
  line-height: 26px;
  // margin-left: 305px;
}
.link_wrap {
  font-size: 14px;

  a {
    text-decoration: underline;
    margin-right: 20px;
    color: #004896;
    font-size: 16px;
    text-underline-offset: 6px;
  }
}
</style>
